import { AmorphicService } from '../../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { ModalService } from '../../../../../../../coverpath-common/angular/services/modal/modal.service';

export abstract class AbstractSplitModalComponent {
  termPolicyDescription: string;
  wlPolicyDescription: string;

  constructor(protected amorphicService: AmorphicService, protected modalService: ModalService) {
    this.termPolicyDescription = `${this.amorphicService.controller.customer.application.secondaryPolicy.term} Year Convertible Term`;
    this.wlPolicyDescription = `Whole Life ${this.amorphicService.controller.customer.application.primaryPolicy.term}`;
  }
}
